interface StatusObject {
  status?: {
    display?: string;
  };
}

interface StatusDisplayProps {
  latestStatus?: StatusObject | null;
  latestEta?: string | null;
  isTimeout?: boolean;
}

/**
 * A reusable component for displaying status and ETA information
 * @param {Object} props
 * @param {Object} props.latestStatus - The latest status object
 * @param {string} props.latestEta - The latest ETA string
 * @param {boolean} props.isTimeout - Whether the request timed out
 * @returns {string} The formatted status display string
 */
const StatusDisplay = ({
  latestStatus,
  latestEta,
  isTimeout,
}: StatusDisplayProps): string => {
  if (isTimeout) {
    return 'Request Failed – Please Contact Air Service via Telephone.';
  }

  return `${latestStatus?.status?.display || ''}${
    latestEta ? ` - ${latestEta}` : ''
  }`;
};

export default StatusDisplay;
